import React from 'react';
const tomes = [{
  label: '0–6m',
  sublabel: 'Reflejos y vínculo',
  color: 'rgb(21, 101, 192)',
  illustration: <svg viewBox="0 0 120 160" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full" data-id="element-252">
        {/* Fondo degradado */}
        <rect width="120" height="160" fill="url(#grad0)" data-id="element-253" />
        <defs data-id="element-254">
          <linearGradient id="grad0" x1="0" y1="0" x2="120" y2="160" gradientUnits="userSpaceOnUse" data-id="element-255">
            <stop offset="0%" stopColor="rgb(30,120,220)" data-id="element-256" />
            <stop offset="100%" stopColor="rgb(10,60,140)" data-id="element-257" />
          </linearGradient>
        </defs>
        {/* Estrellas de fondo */}
        <circle cx="15" cy="20" r="2" fill="white" fillOpacity="0.3" data-id="element-258" />
        <circle cx="100" cy="15" r="1.5" fill="white" fillOpacity="0.2" data-id="element-259" />
        <circle cx="110" cy="50" r="2" fill="white" fillOpacity="0.25" data-id="element-260" />
        <circle cx="10" cy="80" r="1.5" fill="white" fillOpacity="0.2" data-id="element-261" />
        {/* Móvil colgante */}
        <line x1="60" y1="10" x2="60" y2="30" stroke="white" strokeOpacity="0.8" strokeWidth="1.5" data-id="element-262" />
        <line x1="35" y1="30" x2="85" y2="30" stroke="white" strokeOpacity="0.8" strokeWidth="1.5" data-id="element-263" />
        <line x1="35" y1="30" x2="35" y2="44" stroke="white" strokeOpacity="0.6" strokeWidth="1" data-id="element-264" />
        <line x1="60" y1="30" x2="60" y2="42" stroke="white" strokeOpacity="0.6" strokeWidth="1" data-id="element-265" />
        <line x1="85" y1="30" x2="85" y2="44" stroke="white" strokeOpacity="0.6" strokeWidth="1" data-id="element-266" />
        {/* Figuras del móvil */}
        <circle cx="35" cy="48" r="5" fill="white" fillOpacity="0.9" data-id="element-267" />
        <polygon points="60,42 65,52 55,52" fill="white" fillOpacity="0.8" data-id="element-268" />
        <rect x="81" y="44" width="8" height="8" rx="2" fill="white" fillOpacity="0.85" data-id="element-269" />
        {/* Cuna */}
        <path d="M20 130 Q60 118 100 130" stroke="white" strokeOpacity="0.5" strokeWidth="8" strokeLinecap="round" fill="none" data-id="element-270" />
        <line x1="20" y1="130" x2="15" y2="148" stroke="white" strokeOpacity="0.4" strokeWidth="4" strokeLinecap="round" data-id="element-271" />
        <line x1="100" y1="130" x2="105" y2="148" stroke="white" strokeOpacity="0.4" strokeWidth="4" strokeLinecap="round" data-id="element-272" />
        {/* Bebé en la cuna */}
        {/* Cuerpo */}
        <ellipse cx="60" cy="118" rx="22" ry="13" fill="white" fillOpacity="0.95" data-id="element-273" />
        {/* Cabeza */}
        <circle cx="60" cy="96" r="17" fill="white" fillOpacity="0.95" data-id="element-274" />
        {/* Gorrito */}
        <ellipse cx="60" cy="82" rx="14" ry="7" fill="rgb(100,160,255)" fillOpacity="0.7" data-id="element-275" />
        <line x1="46" y1="82" x2="74" y2="82" stroke="rgb(100,160,255)" strokeWidth="2" strokeOpacity="0.5" data-id="element-276" />
        {/* Cara */}
        <circle cx="54" cy="95" r="2" fill="rgb(21,101,192)" data-id="element-277" />
        <circle cx="66" cy="95" r="2" fill="rgb(21,101,192)" data-id="element-278" />
        {/* Ojos cerrados / dormido */}
        <path d="M51 95 Q54 98 57 95" stroke="rgb(21,101,192)" strokeWidth="1.5" strokeLinecap="round" fill="none" data-id="element-279" />
        <path d="M63 95 Q66 98 69 95" stroke="rgb(21,101,192)" strokeWidth="1.5" strokeLinecap="round" fill="none" data-id="element-280" />
        {/* Sonrisa */}
        <path d="M54 103 Q60 108 66 103" stroke="rgb(21,101,192)" strokeWidth="1.5" strokeLinecap="round" fill="none" data-id="element-281" />
        {/* Bracitos */}
        <ellipse cx="38" cy="118" rx="8" ry="5" fill="white" fillOpacity="0.85" transform="rotate(-15 38 118)" data-id="element-282" />
        <ellipse cx="82" cy="118" rx="8" ry="5" fill="white" fillOpacity="0.85" transform="rotate(15 82 118)" data-id="element-283" />
        {/* Manta */}
        <path d="M38 122 Q60 132 82 122" stroke="rgb(100,160,255)" strokeOpacity="0.6" strokeWidth="6" strokeLinecap="round" fill="none" data-id="element-284" />
      </svg>
}, {
  label: '6–12m',
  sublabel: 'Exploración sensorial',
  color: 'rgb(46, 125, 50)',
  illustration: <svg viewBox="0 0 120 160" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full" data-id="element-285">
        <defs data-id="element-286">
          <linearGradient id="grad1" x1="0" y1="0" x2="120" y2="160" gradientUnits="userSpaceOnUse" data-id="element-287">
            <stop offset="0%" stopColor="rgb(60,150,60)" data-id="element-288" />
            <stop offset="100%" stopColor="rgb(20,80,25)" data-id="element-289" />
          </linearGradient>
        </defs>
        <rect width="120" height="160" fill="url(#grad1)" data-id="element-290" />
        {/* Piso */}
        <ellipse cx="60" cy="148" rx="50" ry="10" fill="white" fillOpacity="0.08" data-id="element-291" />
        {/* Juguetes en el piso */}
        {/* Cubo */}
        <rect x="18" y="124" width="18" height="18" rx="3" fill="white" fillOpacity="0.85" data-id="element-292" />
        <line x1="18" y1="124" x2="24" y2="118" stroke="white" strokeOpacity="0.5" strokeWidth="1" data-id="element-293" />
        <line x1="36" y1="124" x2="42" y2="118" stroke="white" strokeOpacity="0.5" strokeWidth="1" data-id="element-294" />
        <line x1="24" y1="118" x2="42" y2="118" stroke="white" strokeOpacity="0.5" strokeWidth="1" data-id="element-295" />
        {/* Pelota */}
        <circle cx="90" cy="133" r="10" fill="white" fillOpacity="0.85" data-id="element-296" />
        <path d="M82 128 Q90 133 98 128" stroke="rgb(46,125,50)" strokeWidth="1.2" fill="none" data-id="element-297" />
        <path d="M82 138 Q90 133 98 138" stroke="rgb(46,125,50)" strokeWidth="1.2" fill="none" data-id="element-298" />
        <line x1="90" y1="123" x2="90" y2="143" stroke="rgb(46,125,50)" strokeWidth="1.2" data-id="element-299" />
        {/* Bebé sentado */}
        {/* Cuerpo */}
        <ellipse cx="60" cy="118" rx="18" ry="14" fill="white" fillOpacity="0.95" data-id="element-300" />
        {/* Piernitas cruzadas */}
        <ellipse cx="44" cy="130" rx="10" ry="6" fill="white" fillOpacity="0.9" transform="rotate(20 44 130)" data-id="element-301" />
        <ellipse cx="76" cy="130" rx="10" ry="6" fill="white" fillOpacity="0.9" transform="rotate(-20 76 130)" data-id="element-302" />
        {/* Cabeza */}
        <circle cx="60" cy="96" r="18" fill="white" fillOpacity="0.95" data-id="element-303" />
        {/* Cabello */}
        <path d="M44 90 Q60 78 76 90" fill="rgb(180,120,60)" fillOpacity="0.8" data-id="element-304" />
        {/* Cara */}
        <circle cx="54" cy="95" r="2.2" fill="rgb(46,125,50)" data-id="element-305" />
        <circle cx="66" cy="95" r="2.2" fill="rgb(46,125,50)" data-id="element-306" />
        <path d="M54 103 Q60 108 66 103" stroke="rgb(46,125,50)" strokeWidth="1.8" strokeLinecap="round" fill="none" data-id="element-307" />
        {/* Cejas curiosas */}
        <path d="M51 90 Q54 87 57 90" stroke="rgb(46,125,50)" strokeWidth="1.2" strokeLinecap="round" fill="none" data-id="element-308" />
        <path d="M63 90 Q66 87 69 90" stroke="rgb(46,125,50)" strokeWidth="1.2" strokeLinecap="round" fill="none" data-id="element-309" />
        {/* Bracito extendido hacia cubo */}
        <path d="M42 114 Q30 118 24 122" stroke="white" strokeOpacity="0.9" strokeWidth="5" strokeLinecap="round" data-id="element-310" />
        {/* Otro bracito */}
        <path d="M78 114 Q88 108 92 106" stroke="white" strokeOpacity="0.9" strokeWidth="5" strokeLinecap="round" data-id="element-311" />
        {/* Destellos sensoriales */}
        <circle cx="20" cy="60" r="3" fill="white" fillOpacity="0.4" data-id="element-312" />
        <circle cx="100" cy="40" r="2" fill="white" fillOpacity="0.3" data-id="element-313" />
        <circle cx="15" cy="100" r="2" fill="white" fillOpacity="0.25" data-id="element-314" />
        <path d="M96 70 L98 74 L102 74 L99 77 L100 81 L96 78 L92 81 L93 77 L90 74 L94 74 Z" fill="white" fillOpacity="0.35" data-id="element-315" />
      </svg>
}, {
  label: '12–18m',
  sublabel: 'Primeros pasos',
  color: 'rgb(200, 70, 0)',
  illustration: <svg viewBox="0 0 120 160" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full" data-id="element-316">
        <defs data-id="element-317">
          <linearGradient id="grad2" x1="0" y1="0" x2="120" y2="160" gradientUnits="userSpaceOnUse" data-id="element-318">
            <stop offset="0%" stopColor="rgb(240,100,20)" data-id="element-319" />
            <stop offset="100%" stopColor="rgb(150,40,0)" data-id="element-320" />
          </linearGradient>
        </defs>
        <rect width="120" height="160" fill="url(#grad2)" data-id="element-321" />
        {/* Piso con huellas */}
        <ellipse cx="30" cy="152" rx="8" ry="4" fill="white" fillOpacity="0.15" data-id="element-322" />
        <ellipse cx="55" cy="155" rx="8" ry="4" fill="white" fillOpacity="0.12" data-id="element-323" />
        <ellipse cx="80" cy="152" rx="8" ry="4" fill="white" fillOpacity="0.15" data-id="element-324" />
        {/* Huellas de pasos */}
        <ellipse cx="35" cy="145" rx="5" ry="3" fill="white" fillOpacity="0.2" transform="rotate(-10 35 145)" data-id="element-325" />
        <ellipse cx="55" cy="148" rx="5" ry="3" fill="white" fillOpacity="0.2" transform="rotate(10 55 148)" data-id="element-326" />
        <ellipse cx="75" cy="145" rx="5" ry="3" fill="white" fillOpacity="0.2" transform="rotate(-10 75 145)" data-id="element-327" />
        {/* Niño caminando */}
        {/* Pierna trasera */}
        <path d="M62 128 Q65 140 70 150" stroke="white" strokeOpacity="0.9" strokeWidth="7" strokeLinecap="round" data-id="element-328" />
        {/* Pierna delantera */}
        <path d="M55 128 Q48 138 42 148" stroke="white" strokeOpacity="0.95" strokeWidth="7" strokeLinecap="round" data-id="element-329" />
        {/* Zapatito izq */}
        <ellipse cx="40" cy="150" rx="8" ry="4" fill="white" fillOpacity="0.9" data-id="element-330" />
        {/* Zapatito der */}
        <ellipse cx="71" cy="151" rx="8" ry="4" fill="white" fillOpacity="0.9" data-id="element-331" />
        {/* Cuerpo */}
        <rect x="46" y="104" width="25" height="28" rx="10" fill="white" fillOpacity="0.95" data-id="element-332" />
        {/* Brazo izquierdo levantado — equilibrio */}
        <path d="M46 112 Q32 100 26 90" stroke="white" strokeOpacity="0.95" strokeWidth="6" strokeLinecap="round" data-id="element-333" />
        {/* Brazo derecho levantado */}
        <path d="M71 112 Q84 100 90 90" stroke="white" strokeOpacity="0.95" strokeWidth="6" strokeLinecap="round" data-id="element-334" />
        {/* Manitos */}
        <circle cx="25" cy="88" r="5" fill="white" fillOpacity="0.85" data-id="element-335" />
        <circle cx="91" cy="88" r="5" fill="white" fillOpacity="0.85" data-id="element-336" />
        {/* Cabeza */}
        <circle cx="58" cy="84" r="20" fill="white" fillOpacity="0.95" data-id="element-337" />
        {/* Cabello */}
        <path d="M40 78 Q58 62 76 78" fill="rgb(180,110,40)" fillOpacity="0.75" data-id="element-338" />
        {/* Cara feliz en movimiento */}
        <circle cx="51" cy="82" r="2.5" fill="rgb(200,70,0)" data-id="element-339" />
        <circle cx="65" cy="82" r="2.5" fill="rgb(200,70,0)" data-id="element-340" />
        <path d="M50 91 Q58 98 66 91" stroke="rgb(200,70,0)" strokeWidth="2" strokeLinecap="round" fill="none" data-id="element-341" />
        {/* Mejillas sonrojadas */}
        <ellipse cx="46" cy="88" rx="5" ry="3" fill="rgb(255,140,100)" fillOpacity="0.35" data-id="element-342" />
        <ellipse cx="70" cy="88" rx="5" ry="3" fill="rgb(255,140,100)" fillOpacity="0.35" data-id="element-343" />
        {/* Líneas de movimiento */}
        <path d="M10 100 Q18 96 14 104" stroke="white" strokeOpacity="0.3" strokeWidth="2" strokeLinecap="round" fill="none" data-id="element-344" />
        <path d="M8 115 Q16 111 12 119" stroke="white" strokeOpacity="0.25" strokeWidth="2" strokeLinecap="round" fill="none" data-id="element-345" />
        <path d="M105 100 Q97 96 101 104" stroke="white" strokeOpacity="0.3" strokeWidth="2" strokeLinecap="round" fill="none" data-id="element-346" />
      </svg>
}, {
  label: '18–24m',
  sublabel: 'Lenguaje y juego',
  color: 'rgb(106, 27, 154)',
  illustration: <svg viewBox="0 0 120 160" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full" data-id="element-347">
        <defs data-id="element-348">
          <linearGradient id="grad3" x1="0" y1="0" x2="120" y2="160" gradientUnits="userSpaceOnUse" data-id="element-349">
            <stop offset="0%" stopColor="rgb(140,50,190)" data-id="element-350" />
            <stop offset="100%" stopColor="rgb(70,10,110)" data-id="element-351" />
          </linearGradient>
        </defs>
        <rect width="120" height="160" fill="url(#grad3)" data-id="element-352" />
        {/* Burbujas de lenguaje flotando */}
        {/* Burbuja grande */}
        <rect x="52" y="12" width="58" height="32" rx="12" fill="white" fillOpacity="0.92" data-id="element-353" />
        <path d="M62 44 L56 54 L70 44" fill="white" fillOpacity="0.92" data-id="element-354" />
        <line x1="60" y1="22" x2="102" y2="22" stroke="rgb(106,27,154)" strokeWidth="2.5" strokeLinecap="round" data-id="element-355" />
        <line x1="60" y1="30" x2="96" y2="30" stroke="rgb(106,27,154)" strokeWidth="2.5" strokeLinecap="round" data-id="element-356" />
        <line x1="60" y1="38" x2="86" y2="38" stroke="rgb(106,27,154)" strokeWidth="2.5" strokeLinecap="round" data-id="element-357" />
        {/* Burbuja mediana */}
        <rect x="8" y="30" width="40" height="22" rx="9" fill="white" fillOpacity="0.75" data-id="element-358" />
        <path d="M38 52 L44 60 L32 52" fill="white" fillOpacity="0.75" data-id="element-359" />
        <line x1="15" y1="38" x2="42" y2="38" stroke="rgb(106,27,154)" strokeWidth="2" strokeLinecap="round" strokeOpacity="0.7" data-id="element-360" />
        <line x1="15" y1="45" x2="36" y2="45" stroke="rgb(106,27,154)" strokeWidth="2" strokeLinecap="round" strokeOpacity="0.7" data-id="element-361" />
        {/* Burbuja pequeña */}
        <circle cx="18" cy="72" r="8" fill="white" fillOpacity="0.5" data-id="element-362" />
        <circle cx="26" cy="62" r="4" fill="white" fillOpacity="0.3" data-id="element-363" />
        <circle cx="34" cy="56" r="2" fill="white" fillOpacity="0.2" data-id="element-364" />
        {/* Niño */}
        {/* Piernas */}
        <path d="M52 140 Q48 152 44 160" stroke="white" strokeOpacity="0.9" strokeWidth="7" strokeLinecap="round" data-id="element-365" />
        <path d="M64 140 Q68 152 72 160" stroke="white" strokeOpacity="0.9" strokeWidth="7" strokeLinecap="round" data-id="element-366" />
        {/* Cuerpo */}
        <rect x="43" y="110" width="30" height="34" rx="12" fill="white" fillOpacity="0.95" data-id="element-367" />
        {/* Brazo señalando burbujas */}
        <path d="M73 118 Q88 100 92 72" stroke="white" strokeOpacity="0.9" strokeWidth="6" strokeLinecap="round" data-id="element-368" />
        <circle cx="92" cy="70" r="5" fill="white" fillOpacity="0.85" data-id="element-369" />
        {/* Otro brazo */}
        <path d="M43 118 Q30 112 22 108" stroke="white" strokeOpacity="0.9" strokeWidth="6" strokeLinecap="round" data-id="element-370" />
        {/* Cabeza */}
        <circle cx="58" cy="90" r="20" fill="white" fillOpacity="0.95" data-id="element-371" />
        {/* Cabello */}
        <path d="M40 82 Q58 68 76 82" fill="rgb(80,40,10)" fillOpacity="0.7" data-id="element-372" />
        {/* Cara hablando */}
        <circle cx="51" cy="88" r="2.5" fill="rgb(106,27,154)" data-id="element-373" />
        <circle cx="65" cy="88" r="2.5" fill="rgb(106,27,154)" data-id="element-374" />
        {/* Boca abierta */}
        <path d="M50 97 Q58 104 66 97" stroke="rgb(106,27,154)" strokeWidth="2" strokeLinecap="round" fill="none" data-id="element-375" />
        <ellipse cx="58" cy="99" rx="6" ry="3.5" fill="rgb(106,27,154)" fillOpacity="0.15" data-id="element-376" />
        {/* Mejillas */}
        <ellipse cx="46" cy="94" rx="5" ry="3" fill="rgb(200,150,255)" fillOpacity="0.4" data-id="element-377" />
        <ellipse cx="70" cy="94" rx="5" ry="3" fill="rgb(200,150,255)" fillOpacity="0.4" data-id="element-378" />
      </svg>
}, {
  label: '24–30m',
  sublabel: 'Motricidad fina',
  color: 'rgb(55, 71, 79)',
  illustration: <svg viewBox="0 0 120 160" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full" data-id="element-379">
        <defs data-id="element-380">
          <linearGradient id="grad4" x1="0" y1="0" x2="120" y2="160" gradientUnits="userSpaceOnUse" data-id="element-381">
            <stop offset="0%" stopColor="rgb(80,100,110)" data-id="element-382" />
            <stop offset="100%" stopColor="rgb(30,45,52)" data-id="element-383" />
          </linearGradient>
        </defs>
        <rect width="120" height="160" fill="url(#grad4)" data-id="element-384" />
        {/* Mesa */}
        <rect x="10" y="118" width="100" height="8" rx="4" fill="white" fillOpacity="0.6" data-id="element-385" />
        <rect x="18" y="126" width="6" height="20" rx="3" fill="white" fillOpacity="0.4" data-id="element-386" />
        <rect x="96" y="126" width="6" height="20" rx="3" fill="white" fillOpacity="0.4" data-id="element-387" />
        {/* Hoja de papel con dibujo */}
        <rect x="28" y="90" width="64" height="30" rx="3" fill="white" fillOpacity="0.97" data-id="element-388" />
        {/* Dibujo del niño en el papel — casa simple */}
        <path d="M50 108 L50 100 L58 94 L66 100 L66 108 Z" stroke="rgb(55,71,79)" strokeWidth="1.5" fill="none" strokeLinejoin="round" data-id="element-389" />
        <rect x="54" y="102" width="8" height="6" rx="1" stroke="rgb(55,71,79)" strokeWidth="1.2" fill="none" data-id="element-390" />
        {/* Sol dibujado */}
        <circle cx="80" cy="98" r="4" stroke="rgb(55,71,79)" strokeWidth="1.2" fill="none" data-id="element-391" />
        <line x1="80" y1="92" x2="80" y2="90" stroke="rgb(55,71,79)" strokeWidth="1" strokeLinecap="round" data-id="element-392" />
        <line x1="85" y1="93" x2="86" y2="92" stroke="rgb(55,71,79)" strokeWidth="1" strokeLinecap="round" data-id="element-393" />
        <line x1="86" y1="98" x2="88" y2="98" stroke="rgb(55,71,79)" strokeWidth="1" strokeLinecap="round" data-id="element-394" />
        {/* Pasto */}
        <path d="M35 114 Q40 108 45 114 Q50 108 55 114" stroke="rgb(55,71,79)" strokeWidth="1.2" fill="none" strokeLinecap="round" data-id="element-395" />
        {/* Lápiz apoyado */}
        <rect x="76" y="106" width="5" height="18" rx="2" fill="rgb(255,220,60)" fillOpacity="0.9" transform="rotate(20 76 106)" data-id="element-396" />
        <polygon points="82,118 79,124 85,122" fill="rgb(200,160,80)" fillOpacity="0.9" transform="rotate(20 82 118)" data-id="element-397" />
        <rect x="76" y="106" width="5" height="4" rx="1" fill="rgb(255,160,160)" fillOpacity="0.8" transform="rotate(20 76 106)" data-id="element-398" />
        {/* Niño sentado dibujando */}
        {/* Cuerpo */}
        <ellipse cx="60" cy="82" rx="16" ry="12" fill="white" fillOpacity="0.95" data-id="element-399" />
        {/* Cabeza */}
        <circle cx="60" cy="60" r="18" fill="white" fillOpacity="0.95" data-id="element-400" />
        {/* Cabello */}
        <path d="M44 52 Q60 40 76 52" fill="rgb(80,50,20)" fillOpacity="0.75" data-id="element-401" />
        {/* Cara concentrada */}
        <ellipse cx="53" cy="58" rx="2.5" ry="2" fill="rgb(55,71,79)" data-id="element-402" />
        <ellipse cx="67" cy="58" rx="2.5" ry="2" fill="rgb(55,71,79)" data-id="element-403" />
        {/* Cejas fruncidas concentrado */}
        <path d="M50 53 Q53 51 56 53" stroke="rgb(55,71,79)" strokeWidth="1.5" strokeLinecap="round" fill="none" data-id="element-404" />
        <path d="M64 53 Q67 51 70 53" stroke="rgb(55,71,79)" strokeWidth="1.5" strokeLinecap="round" fill="none" data-id="element-405" />
        {/* Boca concentrada */}
        <line x1="54" y1="66" x2="66" y2="66" stroke="rgb(55,71,79)" strokeWidth="1.5" strokeLinecap="round" data-id="element-406" />
        {/* Brazo dibujando */}
        <path d="M74 86 Q84 94 84 106" stroke="white" strokeOpacity="0.9" strokeWidth="6" strokeLinecap="round" data-id="element-407" />
        {/* Brazo apoyado */}
        <path d="M46 86 Q36 92 32 96" stroke="white" strokeOpacity="0.9" strokeWidth="6" strokeLinecap="round" data-id="element-408" />
        {/* Lápices de colores al costado */}
        <rect x="10" y="96" width="4" height="16" rx="2" fill="rgb(255,80,80)" fillOpacity="0.8" data-id="element-409" />
        <rect x="15" y="98" width="4" height="14" rx="2" fill="rgb(80,180,80)" fillOpacity="0.8" data-id="element-410" />
        <rect x="20" y="94" width="4" height="18" rx="2" fill="rgb(80,130,255)" fillOpacity="0.8" data-id="element-411" />
      </svg>
}, {
  label: '30–36m',
  sublabel: 'Autonomía y social',
  color: 'rgb(175, 45, 10)',
  illustration: <svg viewBox="0 0 120 160" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full" data-id="element-412">
        <defs data-id="element-413">
          <linearGradient id="grad5" x1="0" y1="0" x2="120" y2="160" gradientUnits="userSpaceOnUse" data-id="element-414">
            <stop offset="0%" stopColor="rgb(220,70,20)" data-id="element-415" />
            <stop offset="100%" stopColor="rgb(120,20,0)" data-id="element-416" />
          </linearGradient>
        </defs>
        <rect width="120" height="160" fill="url(#grad5)" data-id="element-417" />
        {/* Sol */}
        <circle cx="100" cy="22" r="14" fill="white" fillOpacity="0.25" data-id="element-418" />
        <circle cx="100" cy="22" r="9" fill="white" fillOpacity="0.5" data-id="element-419" />
        <line x1="100" y1="5" x2="100" y2="2" stroke="white" strokeOpacity="0.4" strokeWidth="2" strokeLinecap="round" data-id="element-420" />
        <line x1="114" y1="8" x2="116" y2="6" stroke="white" strokeOpacity="0.4" strokeWidth="2" strokeLinecap="round" data-id="element-421" />
        <line x1="118" y1="22" x2="121" y2="22" stroke="white" strokeOpacity="0.4" strokeWidth="2" strokeLinecap="round" data-id="element-422" />
        {/* Pasto */}
        <rect x="0" y="148" width="120" height="12" fill="white" fillOpacity="0.12" rx="4" data-id="element-423" />
        <path d="M0 148 Q10 140 20 148 Q30 140 40 148 Q50 140 60 148 Q70 140 80 148 Q90 140 100 148 Q110 140 120 148" stroke="white" strokeOpacity="0.2" strokeWidth="2" fill="none" data-id="element-424" />
        {/* Niño izquierdo */}
        {/* Piernas */}
        <path d="M32 130 Q28 142 25 152" stroke="white" strokeOpacity="0.9" strokeWidth="6" strokeLinecap="round" data-id="element-425" />
        <path d="M42 130 Q44 142 46 152" stroke="white" strokeOpacity="0.9" strokeWidth="6" strokeLinecap="round" data-id="element-426" />
        {/* Cuerpo */}
        <rect x="24" y="104" width="26" height="28" rx="10" fill="white" fillOpacity="0.95" data-id="element-427" />
        {/* Brazo hacia el otro niño */}
        <path d="M50 114 Q62 110 68 108" stroke="white" strokeOpacity="0.95" strokeWidth="5.5" strokeLinecap="round" data-id="element-428" />
        {/* Brazo libre */}
        <path d="M24 114 Q14 106 10 98" stroke="white" strokeOpacity="0.9" strokeWidth="5.5" strokeLinecap="round" data-id="element-429" />
        {/* Cabeza niño izq */}
        <circle cx="37" cy="84" r="18" fill="white" fillOpacity="0.95" data-id="element-430" />
        <path d="M21 76 Q37 64 53 76" fill="rgb(160,90,30)" fillOpacity="0.7" data-id="element-431" />
        <circle cx="31" cy="82" r="2.2" fill="rgb(175,45,10)" data-id="element-432" />
        <circle cx="43" cy="82" r="2.2" fill="rgb(175,45,10)" data-id="element-433" />
        <path d="M31 90 Q37 96 43 90" stroke="rgb(175,45,10)" strokeWidth="1.8" strokeLinecap="round" fill="none" data-id="element-434" />
        <ellipse cx="26" cy="87" rx="5" ry="3" fill="rgb(255,140,100)" fillOpacity="0.35" data-id="element-435" />
        <ellipse cx="48" cy="87" rx="5" ry="3" fill="rgb(255,140,100)" fillOpacity="0.35" data-id="element-436" />
        {/* Niño derecho */}
        {/* Piernas */}
        <path d="M74 130 Q70 142 68 152" stroke="white" strokeOpacity="0.9" strokeWidth="6" strokeLinecap="round" data-id="element-437" />
        <path d="M86 130 Q88 142 90 152" stroke="white" strokeOpacity="0.9" strokeWidth="6" strokeLinecap="round" data-id="element-438" />
        {/* Cuerpo */}
        <rect x="66" y="104" width="26" height="28" rx="10" fill="white" fillOpacity="0.95" data-id="element-439" />
        {/* Brazo hacia el otro niño */}
        <path d="M66 114 Q56 110 52 108" stroke="white" strokeOpacity="0.95" strokeWidth="5.5" strokeLinecap="round" data-id="element-440" />
        {/* Brazo libre */}
        <path d="M92 114 Q102 106 108 98" stroke="white" strokeOpacity="0.9" strokeWidth="5.5" strokeLinecap="round" data-id="element-441" />
        {/* Cabeza niño der */}
        <circle cx="79" cy="84" r="18" fill="white" fillOpacity="0.95" data-id="element-442" />
        <path d="M63 76 Q79 64 95 76" fill="rgb(60,30,10)" fillOpacity="0.7" data-id="element-443" />
        <circle cx="73" cy="82" r="2.2" fill="rgb(175,45,10)" data-id="element-444" />
        <circle cx="85" cy="82" r="2.2" fill="rgb(175,45,10)" data-id="element-445" />
        <path d="M73 90 Q79 96 85 90" stroke="rgb(175,45,10)" strokeWidth="1.8" strokeLinecap="round" fill="none" data-id="element-446" />
        <ellipse cx="68" cy="87" rx="5" ry="3" fill="rgb(255,140,100)" fillOpacity="0.35" data-id="element-447" />
        <ellipse cx="90" cy="87" rx="5" ry="3" fill="rgb(255,140,100)" fillOpacity="0.35" data-id="element-448" />
        {/* Manos unidas en el centro */}
        <circle cx="58" cy="108" r="7" fill="white" fillOpacity="0.6" data-id="element-449" />
        <path d="M52 104 Q58 100 64 104" stroke="white" strokeOpacity="0.8" strokeWidth="3" strokeLinecap="round" data-id="element-450" />
        {/* Corazón arriba */}
        <path d="M60 28 C60 28 52 20 52 14 C52 10 60 8 60 14 C60 8 68 10 68 14 C68 20 60 28 60 28Z" fill="white" fillOpacity="0.7" data-id="element-451" />
      </svg>
}];
const features = ['✅ Criterio profesional en cada sesión', '✅ 144 sesiones completas con objetivo y cierre', '✅ Fichas imprimibles + Checklists de seguimiento', '✅ Guiones para familias + Protocolos de alerta'];
export function ProductShowcase() {
  return <section className="w-full bg-white px-4 py-10 text-gray-900 text-base leading-6" style={{
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-452">
      <div className="mx-auto max-w-4xl text-center" data-id="element-453">

        {/* Badge */}
        <div className="mb-6 inline-flex items-center gap-2 text-xs font-bold tracking-wide text-cyan-brand border border-cyan-brand/50 bg-cyan-brand/5 rounded-full px-4 py-1.5" data-id="element-454">
          🏆 El sistema más completo de Estimulación Temprana
        </div>

        {/* Subtitle */}
        <h3 className="text-xl font-bold text-cyan-brand m-0 mb-4" data-id="element-455">
          MEGAPACK ESTIMULACIÓN TEMPRANA
        </h3>

        {/* Description */}
        <p className="mx-auto max-w-2xl text-base leading-[24px] text-gray-800 m-0 mb-8" data-id="element-456">
          <strong data-id="element-457">6 Tomos + 6 Bonos — 0 a 36 meses — Todo resuelto.</strong>
          <br data-id="element-458" />
          +380 páginas · 144 sesiones modelo · 24 fichas imprimibles ·
          Neurodesarrollo · Semáforo de alertas · Planificación · Seguimiento ·
          Guiones para familias · Protocolos de derivación. Funciona desde hoy.
        </p>

        {/* Tomes Grid */}
        <div className="relative mx-auto max-w-3xl mb-12" data-id="element-459">
          <div className="grid grid-cols-6 gap-2" data-id="element-460">
            {tomes.map(tome => <div key={tome.label} className="flex flex-col items-center gap-2" data-id="element-461">

                {/* Card ilustrada — ocupa todo el espacio */}
                <div className="w-full aspect-[3/4] rounded-xl overflow-hidden shadow-lg border-2 border-white/20" style={{
              backgroundColor: tome.color
            }} data-id="element-462">
                  {tome.illustration}
                </div>

                {/* Título separado abajo */}
                <div className="text-center" data-id="element-463">
                  <span className="block text-[11px] sm:text-xs font-black text-gray-900" data-id="element-464">
                    {tome.label}
                  </span>
                  <span className="block text-[9px] sm:text-[10px] text-gray-500 leading-tight mt-0.5" data-id="element-465">
                    {tome.sublabel}
                  </span>
                </div>

              </div>)}
          </div>

          {/* Badge overlay */}
          <div className="mt-4 flex justify-center" data-id="element-466">
            <div className="whitespace-nowrap bg-cyan-brand text-[10px] font-black text-white rounded-full px-4 py-1.5 shadow-sm" data-id="element-467">
              6 TOMOS COMPLETOS · 0 A 36 MESES
            </div>
          </div>
        </div>

        {/* Feature Tags */}
        <div className="flex flex-wrap items-center justify-center gap-2" data-id="element-468">
          {features.map(feature => <span key={feature} className="bg-cyan-brand/5 text-xs font-semibold text-cyan-brand border border-cyan-brand/30 rounded-full px-3 py-1.5" data-id="element-469">
              {feature}
            </span>)}
        </div>

      </div>
    </section>;
}